import { useMemo } from "react";
import * as _ from "lodash";
import { CommodityFixings } from "../PricingRequestStepper.slice";

export interface StepConfig {
	show_pricing_section_base_option: boolean;
	show_pricing_section_cap_floor: boolean;
	show_pricing_section_cap_floor_intraday: boolean;
	show_pricing_section_chapter_51: boolean;
	show_pricing_section_clickability: boolean;
	show_pricing_section_curtailability_forward: boolean;
	show_pricing_section_negative_price: boolean;
	show_pricing_section_result_options: boolean;
	show_pricing_section_strike_price: boolean;
	show_pricing_section_addons: boolean;
}

export function useStepConfiguration(
	pricingTypes: CommodityFixings[]
): StepConfig {
	return useMemo(() => {
		const all_pricing_type_countries = _.chain(pricingTypes)
			.map((type) => type.pricing_type_countries)
			.flatten()
			.value();
		const show_pricing_section_base_option =
			all_pricing_type_countries.reduce(
				(prev, curr) => prev || curr.show_pricing_section_base_option,
				false
			);
		const show_pricing_section_cap_floor =
			all_pricing_type_countries.reduce(
				(prev, curr) => prev || curr.show_pricing_section_cap_floor,
				false
			);
		const show_pricing_section_cap_floor_intraday =
			all_pricing_type_countries.reduce(
				(prev, curr) =>
					prev || curr.show_pricing_section_cap_floor_intraday,
				false
			);
		const show_pricing_section_chapter_51 =
			all_pricing_type_countries.reduce(
				(prev, curr) => prev || curr.show_pricing_section_chapter_51,
				false
			);
		const show_pricing_section_clickability =
			all_pricing_type_countries.reduce(
				(prev, curr) => prev || curr.show_pricing_section_clickability,
				false
			);
		const show_pricing_section_curtailability_forward =
			all_pricing_type_countries.reduce(
				(prev, curr) =>
					prev || curr.show_pricing_section_curtailability_forward,
				false
			);
		const show_pricing_section_negative_price =
			all_pricing_type_countries.reduce(
				(prev, curr) =>
					prev || curr.show_pricing_section_negative_price,
				false
			);
		const show_pricing_section_result_options =
			all_pricing_type_countries.reduce(
				(prev, curr) =>
					prev || curr.show_pricing_section_result_options,
				false
			);
		const show_pricing_section_strike_price =
			all_pricing_type_countries.reduce(
				(prev, curr) => prev || curr.show_pricing_section_strike_price,
				false
			);
		const show_pricing_section_addons = all_pricing_type_countries.reduce(
			(prev, curr) => prev || curr.show_pricing_section_addons,
			false
		);

		return {
			show_pricing_section_base_option,
			show_pricing_section_cap_floor,
			show_pricing_section_cap_floor_intraday,
			show_pricing_section_chapter_51,
			show_pricing_section_clickability,
			show_pricing_section_curtailability_forward,
			show_pricing_section_negative_price,
			show_pricing_section_result_options,
			show_pricing_section_strike_price,
			show_pricing_section_addons,
		};
	}, [pricingTypes]);
}
